export default __webpack_public_path__ + "static/media/telegram.453a41f6.webp";